<kt-loader [showLoader]="loading()">
  <div style="align-self: center;">
    <div class="text-danger" *ngIf="showLocationError">Please allow the location permission to start the shift</div>
  </div>
  <div class="kt-widget__head" style="justify-content: space-between;" *ngIf="user$ | async as _user">
    <div class="d-flex me-5">
      <div class="kt-avatar kt-widget__media align-self-center">
        <span *ngIf="isSameUser">
          <a class="kt-media kt-media--circle circle-xl">
            <img *ngIf="_user?.user_business_profile_image_url" alt="Pic" class="shift-user-image profile-pic"
              [src]="_user?.user_business_profile_image_url"
              [class.border-danger]="isLate() && currentStatus === timeSheetEnumRef.NONE"
              [class.border-warning]="currentStatus === timeSheetEnumRef.ONBREAK"
              [class.border-success]="currentStatus === timeSheetEnumRef.STARTED || currentStatus === timeSheetEnumRef.ONLOOP">
          </a>
          <span *ngIf="!_user?.user_business_profile_image_url"
            class="kt-badge kt-badge--xl profile-pic kt-badge--rounded kt-badge--bold kt-badge--username">
            <span>{{(_user?.user_business_first_name?.toUpperCase() + ' ' +
              _user?.user_business_last_name?.toUpperCase() )| firstLetter}}</span>
          </span>
        </span>
        <span *ngIf="!isSameUser">
          <a *ngIf="!isSameUser" class="kt-media kt-media--circle circle-xl">
            <img *ngIf="_selectedUserData?.user_business_profile_image_url" alt="Pic"
              class="shift-user-image profile-pic" [src]="_selectedUserData?.user_business_profile_image_url"
              [class.border-danger]="isLate() && currentStatus === timeSheetEnumRef.NONE"
              [class.border-warning]="currentStatus === timeSheetEnumRef.ONBREAK"
              [class.border-success]="currentStatus === timeSheetEnumRef.STARTED || currentStatus === timeSheetEnumRef.ONLOOP">
          </a>
          <span *ngIf="!_selectedUserData?.user_business_profile_image_url"
            class="kt-badge kt-badge--xl profile-pic kt-badge--rounded kt-badge--bold kt-badge--username">
            <span>{{(_selectedUserData?.user_business_first_name?.toUpperCase() + ' ' +
              _selectedUserData?.user_business_last_name?.toUpperCase() )| firstLetter}}</span>
          </span>
        </span>
        <!-- Note: Late status -->
        <!-- <img src="assets/media/users/100_13.jpg" alt="image" class="user-image border-danger"> -->
      </div>
      <div class="kt-widget__content">
        <div class="kt-widget__section">
          <a href="javascript:void(0);" class="kt-widget__username">
            <span *ngIf="isSameUser">{{_user?.user_business_first_name}} {{_user?.user_business_last_name}}</span>
            <span *ngIf="!isSameUser">{{_selectedUserData?.user_first_name}}
              {{_selectedUserData?.user_last_name}}</span>
            <span *ngIf="isLate() && currentStatus === timeSheetEnumRef.NONE" class="text-danger h6">(Late)</span>
            <span *ngIf="currentStatus !== timeSheetEnumRef.NONE && currentStatus !== timeSheetEnumRef.ONLOOP" class="h6"
              [class.text-warning]="currentStatus === timeSheetEnumRef.ONBREAK"
              [class.text-success]="currentStatus === timeSheetEnumRef.STARTED ">
              ({{currentStatus?.toLowerCase() | titlecase}})</span>
              <!-- || currentStatus === timeSheetEnumRef.ONLOOP -->
            <!-- Note: Late status -->
            <!-- <small class="kt-font-danger">(Late)</small> -->
          </a>
          <div class="h6"><b>Business:</b> {{businessName}} </div>
          <!-- <div class="h6"><b>Role:</b> {{profile | titlecase}} </div> -->
          <div class="h6"><b>Role: </b><span *ngIf="isSameUser">{{userProfileRole | titlecase}}</span> <span
              *ngIf="!isSameUser">{{profile ? profile : _selectedUserData?.user_business_role | titlecase}}</span></div>
          <span class="kt-widget__subtitle" *ngIf="shiftInfo || timesheet">
            <div>Works at {{timesheet?.area?.area_name || shiftInfo?.area?.area_name}}</div>
            <div class="d-inline-block me-3">
              <svg-icon class="svg_icon13x13 location_client_time-svg me-1 d-inline" src="assets/media/iq-svg/without_circle/icon_set_3/location.svg"></svg-icon>
              <span>{{timesheet?.location?.location_name || shiftInfo?.location?.location_name }}</span>
            </div>
            <div class="d-sm-inline-block">
              <svg-icon class="svg_icon13x13 location_client_time-svg d-inline me-1" src="assets/media/iq-svg/without_circle/icon_set_3/client.svg"></svg-icon>
              <span>{{timesheet?.client?.client_name || shiftInfo?.client?.client_name}}</span>
            </div>
            <div class="kt-font-warning" *ngIf="shiftInfo?.shiftStartDate">
              <svg-icon class="svg_icon13x13 location_client_time-svg d-inline me-1" src="assets/media/iq-svg/without_circle/icon_set_3/time.svg"></svg-icon>
              <span>{{(shiftInfo?.shiftStartDate) | TimezoneDateTime }}</span> -
              <span>{{shiftInfo?.shiftEndDate | TimezoneDateTime}}</span>
            </div>
            <div class="text-brand" *ngIf="timeElapsed() && timesheet">
              Duration: {{timeElapsed()}}
            </div>
          </span>
        </div>
      </div>
    </div>

    <div class="update-icons icons"
      *ngxPermissionsOnly="!isLoggedInUserProfile ? permissionV2.MANAGE_OTHER_SHIFT_MANAGE : permissionV2.MANAGE_OWN_SHIFT_MANAGE">
      <ng-container *ngxPermissionsOnly="permissionV2.LOCATION_AREA_TASK">
        <div [class.control-disable]="currentStatus === timeSheetEnumRef.ONBREAK" class="update-icon"
          (click)="taskGroupClickHandler()" ngbTooltip="Task list: {{counts.shift_task_group_count}}" placement="left">
          <!-- <img src="../assets/media/icons/png/aside-icons/Task1x.png" class="image" alt="Task list" /> -->
          <svg-icon class="svg_icon18x22 task_icon-shift_info_main" src="assets/media/iq-svg/without_circle/icon_set_5/task.svg"></svg-icon>
          <span class="kt-badge kt-badge--danger kt-badge--dot kt-badge--lg notify-badge"
            *ngIf="counts.shift_task_group_count">
          </span>
        </div>
      </ng-container>
      <ng-container *ngxPermissionsOnly="permissionV2.FORM_MANAGEMENT">
        <div [class.control-disable]="currentStatus === timeSheetEnumRef.ONBREAK" class="update-icon"
          (click)="formFillHandler()" ngbTooltip="Form: {{counts.shift_form_count}}" placement="left">
          <svg-icon class="svg_icon18x22" src="assets/media/iq-svg/without_circle/icon_set_1/form_icon.svg"></svg-icon>
          <span class="kt-badge kt-badge--danger kt-badge--dot kt-badge--lg notify-badge"
            *ngIf="counts.shift_form_count">

          </span>
        </div>
      </ng-container>
      <!-- <ng-container *ngxPermissionsOnly="permissionV2.LOOP_PATROL">
        <div [class.control-disable]="currentStatus === timeSheetEnumRef.ONBREAK" class="update-icon"
          (click)="loopClickHandler()" ngbTooltip="Loop: {{counts.shift_loop_count}}" placement="left">
          <svg-icon class="svg_icon18x22 " src="assets/media/iq-svg/without_circle/icon_set_1/loop_top_icon_(dark_color).svg"></svg-icon>
          <span class="kt-badge kt-badge--danger kt-badge--dot kt-badge--lg notify-badge"
            *ngIf="counts.shift_loop_count">
          </span>
        </div>
      </ng-container> -->
      <ng-container *ngxPermissionsOnly="permissionV2.LOOP_PATROL">
        <div [class.control-disable]="currentStatus === timeSheetEnumRef.ONBREAK" class="update-icon"
          (click)="patrolClickHandler()" ngbTooltip="Patrol: {{counts.shift_patrol_count}}" placement="left">
          <svg-icon class="svg_icon18x22 " src="assets/media/iq-svg/without_circle/icon_set_1/patrolicon.svg"></svg-icon>
          <span class="kt-badge kt-badge--danger kt-badge--dot kt-badge--lg notify-badge"
            *ngIf="counts.shift_patrol_count">
          </span>
        </div>
      </ng-container>
      <div [class.control-disable]="currentStatus === timeSheetEnumRef.ONBREAK" class="update-icon"
        (click)="rewardClickHandler()" ngbTooltip="Rewards: {{counts.shift_reward_count}}" placement="left">
        <svg-icon class="svg_icon18x22 " src="assets/media/iq-svg/without_circle/icon_set_5/reward.svg"></svg-icon>
        <span class="kt-badge kt-badge--danger kt-badge--dot kt-badge--lg notify-badge"
          *ngIf="counts.shift_reward_count">
        </span>
      </div>
      <ng-container *ngxPermissionsOnly="[permissionV2.LOCATION_RESOURCE_FILES_ACCESS, permissionV2.LOCATION_RESOURCE_NOTES_ACCESS]">
        <div class="update-icon" (click)="resourceClickHandler()" ngbTooltip="Resources" placement="left">
          <svg-icon class="svg_icon18x22 " src="assets/media/iq-svg/without_circle/icon_set_3/shift_resources.svg"></svg-icon>
        </div>
      </ng-container>
      <ng-container *ngxPermissionsOnly="[permissionV2.LOCATION_RESOURCE_SITE_FOLDER_FILES_ACCESS, permissionV2.LOCATION_RESOURCE_SITE_FOLDER_NOTES_ACCESS]">
        <div class="update-icon" (click)="resourceClickHandler('site-folder')" ngbTooltip="Site Folder" placement="left">
          <svg-icon class="svg_icon18x22 " src="assets/media/iq-svg/without_circle/icon_set_3/folder.svg"></svg-icon>
        </div>
      </ng-container>
    </div>
  </div>

  <div class="kt-widget__action mt-2 buttons-container"
    *ngxPermissionsOnly="!isLoggedInUserProfile ? permissionV2.MANAGE_OTHER_SHIFT_MANAGE : permissionV2.MANAGE_OWN_SHIFT_MANAGE">
    <button type="button"
      *ngIf="  (shiftTimeSheetDetails?.location ? shiftTimeSheetDetails?.location?.location_timesheet_allow_start_shift_via_web_browser_enable : true) &&  shiftInfo || timesheet"
      class="btn btn-brand btn-sm button-width" (click)="shiftDetailsClickHandler()">Shift Details</button>
    <button type="button"
      *ngIf="(shiftTimeSheetDetails?.location ? shiftTimeSheetDetails?.location?.location_timesheet_allow_start_shift_via_web_browser_enable : true)  && shiftInfo && currentStatus === timeSheetEnumRef.NONE "
      class="btn btn-success btn-sm button-width" [disabled]="loading()" (click)="startShiftHandler()">Start Shift</button>
    <button type="button" *ngIf="!shiftInfo && currentStatus === timeSheetEnumRef.NONE"
      class="btn btn-success btn-sm button-width" [disabled]="loading()" (click)="startShiftHandler()">Start Shift</button>
    <button type="button" *ngIf="currentStatus !== timeSheetEnumRef.ONBREAK && currentStatus !== timeSheetEnumRef.NONE"
      class="btn btn-sm btn-warning button-width" [disabled]="loading()" (click)="startBreakClickHandler()">Start Break</button>
    <button type="button"
      *ngIf="currentStatus !== timeSheetEnumRef.ONBREAK && currentStatus !== timeSheetEnumRef.NONE && currentStatus !== timeSheetEnumRef.ONLOOP"
      class="btn btn-sm btn-warning button-width" (click)="makeScanClickHandler()">Make Scan</button>
    <!-- <button type="button" *ngIf="currentStatus === timeSheetEnumRef.ONLOOP" class="btn btn-sm btn-warning button-width"
      (click)="makeLoopScanHandler()">Make Loop Scan</button> -->
    <button type="button" *ngIf="currentStatus === timeSheetEnumRef.ONBREAK" class="btn btn-sm btn-danger button-width"
      (click)="endBreakClickHandler()">End Break</button>
    <!-- <ng-container *ngxPermissionsOnly="permissionV2.LOOP_PATROL">
      <button type="button" (click)="startLoopClickHandler()"
        *ngIf="currentStatus !== timeSheetEnumRef.ONLOOP && currentStatus !== timeSheetEnumRef.NONE && counts.shift_loop_count && currentStatus != timeSheetEnumRef.ONBREAK"
        class="btn btn-sm btn-warning button-width">Start
        Loop</button>
    </ng-container> -->
    <!-- <button type="button" *ngIf="currentStatus === timeSheetEnumRef.ONLOOP" class="btn btn-sm btn-danger button-width"
      (click)="endLoopClickHandler()">End Loop</button> -->
    <button type="button"
      *ngIf="(shiftTimeSheetDetails?.location ?   shiftTimeSheetDetails?.location?.location_timesheet_allow_start_shift_via_web_browser_enable : true)  &&  currentStatus !== timeSheetEnumRef.NONE && currentStatus !== timeSheetEnumRef.ONBREAK "
      class="btn btn-sm btn-danger button-width"
      (click)="shouldEndShift()">End
      Shift</button>
      <!-- [disabled]="currentStatus === timeSheetEnumRef.ONLOOP "  -->
    <ng-container *ngxPermissionsOnly="permissionV2.HANDOVER_NOTES_ACCESS">
      <button type="button" class="btn btn-sm btn-brand" style="min-width: 124px;"
        (click)="handoverNotesClickHandler()">Handover
        Notes
        <div *ngIf="unseenHandoverNotes"
          class="mt-n3 kt-badge kt-badge--danger kt-badge--dot kt-badge--sm kt-pulse kt-pulse--danger request ng-star-inserted">
          <span _ngcontent-atp-c7="" class="kt-pulse__ring"></span>
        </div>
      </button>
    </ng-container>
    <!-- Only for businesses with the Advance Task feature (bf_access_advance_task) -->
    <ng-container *ngxPermissionsOnly="permissionV2.ADVANCE_TASK">
      <button type="button" *ngIf="currentStatus !== timeSheetEnumRef.NONE"
        class="btn btn-sm btn-brand button-width task-activity-btn" (click)="taskActivityClickHandler()">Task Activity
        <span *ngIf="hasAdvanceTask()"
          class="kt-badge kt-badge--danger kt-badge--dot kt-badge--sm kt-pulse kt-pulse--danger task-activity-dot">
          <span class="kt-pulse__ring"></span>
        </span>
      </button>
    </ng-container>
  </div>
</kt-loader>